import { logger } from '@libs/core/utils';
import apiProxyClient from '@libs/api-proxy-client';

type FetchStockInfoForIDs = {
    productIds: number[];
    storeId: number | undefined;
};

export const fetchStockInfoForIDs = async ({
    productIds,
    storeId,
}: FetchStockInfoForIDs) => {
    if (!storeId) {
        return {};
    }

    try {
        const storeSku = productIds.map(productId => ({
            sku: String(productId),
            store: String(storeId),
        }));

        const inventoriesResponse =
            await apiProxyClient.inventory.getProductInventoryPairs(storeSku);

        return (
            inventoriesResponse?.reduce<Record<string, boolean>>(
                (result, { sku, ...stores }) => {
                    const hasInventory = Object.values(stores).some(
                        inventory => (inventory as number) >= 1
                    );
                    if (hasInventory) {
                        result[sku] = true;
                    }
                    return result;
                },
                {}
            ) ?? {}
        );
    } catch (error) {
        logger.error('Error fetch stock info for IDs: %o', error);

        return {};
    }
};
